import { render, staticRenderFns } from "./PeerGroupMemberListArchived.vue?vue&type=template&id=64f8942a&"
import script from "./PeerGroupMemberListArchived.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupMemberListArchived.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports